import { useCryptoPrice } from "@/hooks/useCryptoPrice";
import { TrendingUp, TrendingDown } from "lucide-react";

const LivePriceStrip = () => {
  const { data, isLoading } = useCryptoPrice('bitcoin');
  
  if (isLoading) return null;

  const price = data?.usd || 0;
  const change24h = data?.usd_24h_change || 0;
  const marketCap = data?.usd_market_cap || 0;
  const volume24h = data?.usd_24h_vol || 0;
  const isPositive = change24h > 0;

  return (
    <div className="bg-muted/50 border-b border-border">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-1.5 text-xs md:text-sm">
          <div className="flex items-center gap-4 md:gap-6 flex-wrap">
            <div className="flex items-center gap-2">
              <span className="text-muted-foreground">Current Price</span>
              <span className="font-semibold text-foreground">
                ${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
            
            <div className="flex items-center gap-2">
              <span className="text-muted-foreground">24h Change</span>
              <span className={`font-semibold flex items-center gap-1 ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
                {isPositive ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
                {isPositive ? '+' : ''}{change24h.toFixed(2)}%
              </span>
            </div>
            
            <div className="flex items-center gap-2">
              <span className="text-muted-foreground">Market Cap</span>
              <span className="font-semibold text-foreground">
                ${(marketCap / 1e9).toFixed(2)}B
              </span>
            </div>
            
            <div className="flex items-center gap-2">
              <span className="text-muted-foreground">24h Volume</span>
              <span className="font-semibold text-foreground">
                ${(volume24h / 1e9).toFixed(2)}B
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LivePriceStrip;
